export const keyIsModified = evt => evt.metaKey || evt.ctrlKey;

const inputElementRegex = /^(input|textarea)$/i;
export const targetIsInput = evt => inputElementRegex.test(evt.target.tagName);
